module.exports = __webpack_public_path__ + "static/img/recall-rule.8eba27f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/midAutumnRecall/recall/recall-rule.png
// module id = jOrI
// module chunks = 1